<template>
  <div>
    <div class="BlockList">
      <div class="BlockList-W">
        <div class="BlockList_Inp"><Homseach></Homseach></div>
        <div class="Blockbox">
          <div class="Blockboxli">
            <listbox>
              <template #headers> Number of Blocks </template>
              <template #footers> Last 24h </template>
              <template #leftcon> {{   Number(totalBlockCount).toLocaleString() }} </template>
              <template #lefttit> Total </template>
              <template #rightcon> +{{  Number(yesterdayBlockCount).toLocaleString() }} </template>
            </listbox>
          </div>
          <div class="Blockboxli">
            <listbox>
              <template #headers> Stats on Burned TTOS </template>
              <template #footers> Yesterday </template>
              <template #leftcon> {{  Number(totalBurn).toLocaleString() }} </template>
              <template #rightcon> {{  Number(yesterdayBurn).toLocaleString()}} </template>
              <template #lefttit> Total </template>
            </listbox>
          </div>
          <div class="Blockboxli">
            <listbox>
              <template #headers> Average Block Time <el-tooltip
                          placement="right"
                          popper-class="toolTipClass"
                        >
                          <div slot="content">
                            This value is calculated once a minute
                          </div>
                          <img style="width: 16px;height: 16px;margin-left: 4px;" src="@/assets/pc/Index/tip.png" />
                        </el-tooltip></template>
              <template #leftcon> {{ avgBlockTime }}s </template>
            </listbox>
          </div>
          <!-- <listbox></listbox> -->
        </div>
        <!-- <div>
          <BlocksList @change="getpagenums($event)"></BlocksList>
        </div> -->
      </div>
      <div class="Blocks">
        <div class="Block_Top">
          <span
            >Blocks <b class="total notranslate"> ({{ Number(total1).toLocaleString() }})</b></span
          >
          <span> </span>
        </div>
        <div v-show="list.length > 0">
          <div class="Block_list">
            <ul class="block_list_Top">
              <li>Blocks Hash</li>
              <li>Block</li>
              <li>Age</li>
              <li>Pack Node</li>
              <li>Txn</li>
              <li>Gas</li>
            </ul>
          </div>
          <div class="Block_List_center notranslate">
            <ul>
              <li v-for="(item, index) in list" :key="index">
                <p>
                  <span @click="Hash(item.blockHash)">{{
                    item.blockHash
                  }}</span>
                </p>
                <p>
                  <span @click="Block(item.height)">{{ item.height }}</span>
                </p>
                <p>
                  {{ item.blockTime }}
                  <!-- <span class="Hover1">
                  <span class="Hover"
                    >{{ TimeDate[index] }}<i class="iconfont">&#xe600;</i></span
                  >
                </span> -->
                </p>

                <p @click="Address(item.packer1)" style="display: flex;">
                  <img :src="item.packerLogo" /><span style="display: block;width:120px; text-align: left;margin-left: 6px; overflow:hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          -o-text-overflow:ellipsis;">{{ item.packerName }}</span>
                </p>
                <p>{{ item.tradeNums }}</p>
                <p>{{ item.gas }} TTOS</p>
              </li>
            </ul>
          </div>
          <div  :class="list.length>10?'Block_List_Bottom':''">
            <el-pagination
              ref="Pagination"
              :page-size="20"
              :current-page.sync="PaginationIndex"
              background
              layout="prev, pager,
      next"
              @current-change="CurrentChange"
              :total="total1"
            >
            </el-pagination>
          </div>
        </div>
        <div v-show="list.length <= 0">
          <EmptyState />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Listbox from "@/components/pc/Listbox.vue";
import Homseach from "@/components/pc/serch.vue";
import Homeinput from "../Home/Home_input.vue";
// import BlocksList from "./BlocksList";
import { GetBlockList } from "@/assets/server/api";
import Pagination from "./Pagination";
import Pagination2 from "./Pagination2.vue";
import EmptyState from "../EmptyState/EmptyState.vue";
// import { BlockList } from "@/assets/server/api";
import { timestampConvertTime } from "@/utils/utils";
import { goPAGE, formatSeconds, listType, getSubStr } from "@/utils/utils";
export default {
  data() {
    return {
      list: [],
      PaginationIndex: 1,
      total1: null,
      nowLang: "",
      TimeDate: [],
      Page1: "",
      avgBlockTime: "",
      totalBlockCount: "",
      yesterdayBlockCount: null,
      yesterdayBurn: "",
      totalBurn: "",
      packerName:"",
      logo:require('@/assets/pc/Index/vers.png')
    };
  },
  components: {
    Pagination,
    EmptyState,
    Pagination2,
    Homeinput,

    Homseach,
    Listbox,
  },
  mounted() {
    this.PaginationIndex =  1;
    this.blockList();
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  methods: {
    CurrentChange(val) {
      this.PaginationIndex = val;
      this.setContextData("tiaozhuan1", this.PaginationIndex);
      this.blockList();
    },
    async blockList() {
      this.Page1 = this.getContextData("tiaozhuan1") || 1;
      const params = {
        pageNum: this.PaginationIndex,
        pageSize: 20,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      await GetBlockList(formData).then((res) => {
      //  console.log(res);
        this.list = res.result.blockList;
        this.avgBlockTime = res.result.avgBlockTime;
        this.totalBlockCount = res.result.totalBlockCount;
        this.yesterdayBlockCount = res.result.yesterdayBlockCount;
        this.yesterdayBurn =parseFloat(res.result.yesterdayBurnIncrease).toFixed(3);
        if(this.yesterdayBurn>0){
          this.yesterdayBurn='+'+this.yesterdayBurn;
        }
        this.totalBurn = res.result.currentBurn;
   //     console.log(this.list);
        this.total1 = res.result.totalBlockCount;
        this.index = 1;
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        for (let i = 0; i < this.list.length; i++) {
         
          let timestamp = Math.floor(this.list[i].blockTime / 1000);
       

          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list[i].blockTime = formatSeconds(s);
          this.list[i].packer1 = this.list[i].packer;
          this.list[i].packer = getSubStr(this.list[i].packer, 0, 6);
          if(this.list[i].packerLogo==""){
          this.list[i].packerLogo=this.logo;
          } 
          if(this.list[i].packerName==""){
            this.list[i].packerName= this.list[i].packer;
          }
        }
      });
    },
    Block(index) {
      this.$router.push({
        path: "/pc/BkHeight",
        query: { height: index },
      });
    },
    Hash(index) {
   //   console.log(index);
      this.$router.push({ path: "/pc/BkDetail", query: { blockHash: index } });
    },
    Address(index) {
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: index },
      });
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
    setContextData: function (key, value) {
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
  },
};
</script>

<style lang="less" scoped>
.BlockList {
  width: 100%;
  height: 1770px;
  // border: 1px solid red;
  background: #13161b;
  .BlockList-W {
    width: 1160px;
    margin: 0 auto;
    
    padding-bottom: 36px;
    background: #13161b;
    
    .BlockList_Inp {
      padding: 40px 0;
    }
    .Blockbox {
      margin-bottom: 20px;
      display: flex;
      .Blockboxli {
        width: 373px;
        height: 131px;
        background: #0b0c0f;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        margin-right: 20px;
      }
    }
  }
  .Blocks {
    margin: 0 auto;
    padding: 20px 20px;
    background: #0b0c0f;
    width: 1160px;
    height: 1570px;
    border-radius: 16px 16px 16px 16px;
    .Block_Top {
      margin-bottom: 24px;
      display: flex;
      span {
        flex: 1;
        .total {
          display: inline-block;
          font-size: 18px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          line-height: 24px !important;
        }
      }
      span:nth-child(1) {
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        line-height: 24px;
        -webkit-background-clip: text;
      }
    }
    .Block_list {
      .block_list_Top {
        display: flex;
        width: 1120px;

        height: 60px;
        background: #14151a;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        padding: 0 20px;
        li {
          font-size: 16px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #898b8d;
          line-height: 62px;
          -webkit-background-clip: text;
        }
        li:nth-child(1) {
          flex: 0 0 30%;
        }
        li:nth-child(2) {
          flex: 0 0 17%;
        }
        li:nth-child(3) {
          flex: 0 0 18%;
        }
        li:nth-child(4) {
          flex: 0 0 15%;
        }
        li:nth-child(5) {
          flex: 0 0 10%;
          text-align: center;
        }
        li:nth-child(6) {
          flex: 0 0 15%;
          text-align: center;
        }
      }
    }
    .Block_List_center {
      ul {
        height: 620px;
        padding: 0 20px;
        li:last-child{
        border-bottom: none;
      }
        li {
          display: flex;
          height: 62px;
          border-bottom: 1px solid #22252e;
          line-height: 62px;
          p {
            font-size: 14px;
            font-family: SF Pro Text-Regular, SF Pro Text;
            font-weight: 400;
            -webkit-background-clip: text;
            img{
              width: 24px;
              height: 24px;
              border-radius: 50%;
            }
          }
        }
        // li:nth-child(10) {
        //   border: none;
        // }
        p:nth-child(1) {
          flex: 0 0 30%;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
          span {
            display: inline-block;
            width: 280px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
          }
        }
        p:nth-child(1):hover,
        p:nth-child(2):hover,
        p:nth-child(4):hover {
          color: #00e79a;
        }
        p:nth-child(2) {
          flex: 0 0 17%;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          position: relative;
          cursor: pointer;
          .Hover1 {
            display: none;
            .Hover {
              padding: 3px 10px;
              display: inline-block;
              line-height: 20px;
              position: absolute;
              top: -10px;
              left: 0px;
              background-color: #3c485c;
              border-radius: 5px;
              i {
                position: absolute;
                top: 18px;
                left: 40%;
                transform: rotate(180deg);
                color: #3c485c;
              }
            }
          }
        }
        p:nth-child(2):hover {
          .Hover1 {
            display: block !important;
          }
        }
        p:nth-child(3) {
          flex: 0 0 18%;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #898b8d;
          span {
            display: inline-block;
            width: 280px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        p:nth-child(4) {
          flex: 0 0 15%;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
          img {
            margin-top: 20px;
            margin-right: 6px;
          }
        }
        p:nth-child(5) {
          flex: 0 0 10%;
          text-align: center;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #898b8d;
        }
        p:nth-child(6) {
          flex: 0 0 15%;
          text-align: center;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #898b8d;
        }
      }
    }
    .Block_List_Bottom {
      margin-top: 650px;
    }
  }
}

.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
